import React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import useMobileView from '../../hooks/useMobileView'
import Dashboard from './Dashboard/Dashboard'
import { useLocation } from 'react-router-dom'
import { selectReportNameFromRoute } from '../../App'

const ReportsPage: React.FC<RouteComponentProps<{ name: string }>> = (
  props
) => {
  const isMobileView = useMobileView()
  const location = useLocation()
  const { pathname } = location

  const reportName = selectReportNameFromRoute(pathname)
  return <Dashboard layoutMobile={isMobileView} reportId={reportName} />
}

export default ReportsPage
